import { canv } from "@/canv/global";
import { getContrastColor } from "@/canv/utils";
import { STICKER_COLORS, stickerWidget } from "@/elements/sticker";
import { Group } from "@/group";
import { toolBase } from "@/tools/toolBase";

export class stickerTool extends toolBase {
    constructor() {
        super();
        this.color = STICKER_COLORS[0];
        this.contrastColor = getContrastColor(STICKER_COLORS[0]);
    }

    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5714 20.3571H4.92857C4.58757 20.3571 4.26055 20.2216 4.01943 19.9805C3.77831 19.7394 3.64285 19.4124 3.64285 19.0714V4.92854C3.64285 4.58754 3.77831 4.26052 4.01943 4.0194C4.26055 3.77828 4.58757 3.64282 4.92857 3.64282H19.0714C19.4124 3.64282 19.7394 3.77828 19.9806 4.0194C20.2217 4.26052 20.3571 4.58754 20.3571 4.92854V14.5714M14.5714 20.3571L20.3571 14.5714M14.5714 20.3571V15.2143C14.5714 15.0438 14.6392 14.8802 14.7597 14.7597C14.8803 14.6391 15.0438 14.5714 15.2143 14.5714H20.3571" stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Стикер";
    }

    getToolHotKey() {
        return "N";
    }

    select() {
        super.select();
        this.openSubMenu();
    }

    unselect() {
        super.unselect();
        this.ghostStartX = null;
        this.ghostStartY = null;
        this.closeSubMenu();
    }

    handleSetColor = (e: PointerEvent) => {
        const target = e.currentTarget;
        if (!(target instanceof HTMLButtonElement)) {
            return;
        }
        const newColor = target.getAttribute("data-sticker-color");
        const contrastColor = target.getAttribute("data-sticker-text-color");
        if (!newColor || !contrastColor) {
            return;
        }
        this.color = newColor;
        this.contrastColor = contrastColor;
        const buttons = this.subMenu?.querySelectorAll(".stickerTool_colorButton");
        buttons?.forEach((button) => {
            button.classList.remove("stickerTool_colorButtonSelected");
        });
        target.classList.add("stickerTool_colorButtonSelected");
        canv.redraw();
    };

    setColor = (color: string) => {
        this.color = color;
    };

    openSubMenu() {
        const subMenu = document.createElement("div");
        subMenu.classList.add("stickerTool_subMenu");

        STICKER_COLORS.forEach((color) => {
            const selectColorButton = document.createElement("button");
            selectColorButton.setAttribute("type", "button");
            selectColorButton.classList.add("stickerTool_colorButton");
            if (color === this.color) {
                selectColorButton.classList.add("stickerTool_colorButtonSelected");
            }
            const contrastColor = getContrastColor(color);
            selectColorButton.setAttribute("data-sticker-color", color);
            selectColorButton.setAttribute("data-sticker-text-color", contrastColor);
            const colorBox = document.createElement("span");
            colorBox.style.setProperty("--sticker-color", color);
            colorBox.style.setProperty("--contrast-color", contrastColor);
            colorBox.classList.add("stickerTool_colorBox");
            colorBox.innerHTML = `
            <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                <path d="m14 3.5-8.25 9-3.75-4.09091" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="1.5" />
            </svg>
            `;
            selectColorButton.appendChild(colorBox);
            selectColorButton.addEventListener("click", this.handleSetColor);

            subMenu.appendChild(selectColorButton);
        });

        document.body.prepend(subMenu);

        this.subMenu = subMenu;

        this.locateSubMenu(this.getToolClass(), "stickerTool_subMenu");
    }

    closeSubMenu() {
        this.subMenu?.remove();
        this.subMenu = null;
    }

    createSticker() {
        const pt = canv.actionManager.getActionPoint();

        const newElement = new stickerWidget(pt.x - 125, pt.y - 125, this.color);
        newElement.textPart.menuTextColor(this.contrastColor, true);
        const newGroup = new Group(true);
        newElement.setParent(newGroup);

        canv.canvasController.addGroup(newGroup);

        canv.eventManager.openRecord();
        canv.eventManager.createBuildEvent("create", newGroup);
        canv.eventManager.closeRecord();

        canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(newGroup);

        newElement.textPart.menuMobileEdit.bind(newElement)(false);
    }

    TryAction(type: string) {
        if (type === "mouseup") {
            this.createSticker();
        } else if (type === "mousemove") {
            const pt = canv.actionManager.getActionPoint();

            this.ghostStartX = pt.x;
            this.ghostStartY = pt.y;
        }

        canv.redraw();
    }

    draw() {
        if (this.ghostStartX == null || this.ghostStartY == null) {
            return;
        }
        canv.ctx.save();
        canv.ctx.fillStyle = this.color;
        canv.ctx.globalAlpha = 0.2;
        canv.ctx.lineWidth = 2 / canv.m[0];
        canv.ctx.fillRect(this.ghostStartX - 125, this.ghostStartY - 125, 250, 250);
        canv.ctx.restore();
    }

    name = "stickerTool";
    color: string;
    contrastColor: string;
    subMenu: HTMLDivElement | null = null;

    ghostStartX: number | null = null;
    ghostStartY: number | null = null;
}
